<template>
    <PcMain v-if="isPc" :language="language" />
    <MoMain v-else :language="language" />
</template>

<script>
import PcMain from './PcMain.vue'
import MoMain from './MoMain.vue'

export default {
    props: ['language'],
    components: { PcMain, MoMain },
    data() {
        return {
            isPc: window.innerWidth >= 1024
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.isPc = window.innerWidth >= 1024
        }
    }
}
</script>
